export default "__VITE_ASSET__C4vzLO5U__"